<template>
  <div class="user-center-container">
    <div class="container">
      <h2>个人中心</h2>
      
      <div class="user-info-card">
        <div class="avatar-container">
          <el-avatar :size="100" class="user-avatar">
            {{ userInitial }}
          </el-avatar>
        </div>
        
        <div class="user-info">
          <el-descriptions column="1" border>
            <el-descriptions-item label="用户名">{{ userInfo.username }}</el-descriptions-item>
            <el-descriptions-item label="昵称">{{ userInfo.nickname }}</el-descriptions-item>
            <el-descriptions-item label="邮箱">{{ userInfo.email }}</el-descriptions-item>
            <el-descriptions-item label="注册时间">{{ formatDateTime(userInfo.createTime) }}</el-descriptions-item>
            <el-descriptions-item label="角色">
              <el-tag v-for="role in userInfo.roles" :key="role" type="info" style="margin-right: 5px;">
                {{ role.replace('ROLE_', '') }}
              </el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      
      <div class="action-buttons">
        <el-button type="primary" @click="handleEdit">编辑资料</el-button>
        <el-button type="warning" @click="handleChangePassword">修改密码</el-button>
        <el-button type="danger" @click="handleLogout">退出登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/api/user'
import { formatDateTime } from '@/utils/format'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'UserCenter',
  data() {
    return {
      userInfo: {
        username: '',
        nickname: '',
        email: '',
        createTime: '',
        roles: []
      }
    };
  },
  computed: {
    ...mapGetters(['username']),
    // 获取用户名首字母
    userInitial() {
      return this.userInfo.nickname && this.userInfo.nickname.charAt(0).toUpperCase() || 
             this.userInfo.username && this.userInfo.username.charAt(0).toUpperCase() || 'U';
    }
  },
  created() {
    this.loadUserInfo();
  },
  methods: {
    ...mapActions(['logout']),
    
    // 加载用户信息
    async loadUserInfo() {
      try {
        const response = await getUserInfo();
        this.userInfo = response.data;
      } catch (error) {
        this.$message.error('加载用户信息失败: ' + (error.message || '未知错误'));
      }
    },
    
    // 编辑资料
    handleEdit() {
      this.$message.info('编辑资料功能开发中');
      // 实际项目中这里应该打开编辑资料的弹窗或跳转到编辑页面
    },
    
    // 修改密码
    handleChangePassword() {
      this.$message.info('修改密码功能开发中');
      // 实际项目中这里应该打开修改密码的弹窗
    },
    
    // 退出登录
    handleLogout() {
      this.$confirm('确定要退出登录吗?', '确认退出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.logout();
        this.$router.push('/login');
        this.$message.success('退出登录成功');
      }).catch(() => {
        // 取消退出
      });
    },
    
    // 格式化日期时间
    formatDateTime
  }
};
</script>

<style scoped>
.user-center-container {
  padding-top: 80px;
  padding-bottom: 40px;
}

.user-center-container h2 {
  margin-bottom: 30px;
  color: #1f2d3d;
}

.user-info-card {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 30px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.avatar-container {
  margin-right: 30px;
}

.user-avatar {
  background-color: #409eff;
  font-size: 40px;
}

.user-info {
  flex: 1;
}

.action-buttons {
  display: flex;
  gap: 10px;
}
</style>
    